import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("",{ moduleName: "garaje/pods/components/employees/profile-photo/uploader/input/template.hbs" })